// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"ZZ-z","trustedRetailerTooltipWrapper":"_Z-z"};